import React from 'react';
import useTranslation from '../../../../../hooks/useTranslation';
import Link from '../../link';
import RichText from '../../rich-text';
import { EventPosition } from '../../../../../services/analytics-interfaces';

export type NavigationItemProps = {
	link?: string;
	label: string;
	target?: string;
	title: string;
};

export const NavItem: React.FC<NavigationItemProps> = ({
	link,
	label,
	target = '_blank',
	title,
}: NavigationItemProps) => {
	const { t } = useTranslation();
	if (link) {
		return (
			<Link
				className="text-xs lg:text-sm text-font-menu font-semibold px-3 lg:px-4 first:pl-0 last:pr-0 no-underline hover:underline"
				href={link}
				target={target}
				title={title && t(title)}
				rel={ target === '_blank' ? 'noreferrer' : undefined }
				position={EventPosition.Header}>
				<RichText html={t(label)} />
			</Link>
		);
	} else {
		return (
			<span className="text-xs lg:text-sm text-font-menu font-medium px-3 lg:px-4 first:pl-0 last:pr-0">
				{t(label)}
			</span>
		);
	}
};
